import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../component-library/icon';

const AiButtonDebug = ({
	action,
}) => (
	<button
		type="button"
		className="ignite-ai__button-rating"
		title="Debug time!"
		onClick={() => action()}
	>
		<Icon icon="bug" />
	</button>
);

export default AiButtonDebug;

AiButtonDebug.propTypes = {
	action: PropTypes.func.isRequired,
};
